module.exports = __webpack_public_path__ + "r-v3/img/cam_line_white.722f37f0.svg";